import { render, staticRenderFns } from "./FuelStorageOrderCreateOrUpdate.vue?vue&type=template&id=bbf53dd8&scoped=true&"
import script from "./FuelStorageOrderCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./FuelStorageOrderCreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FuelStorageOrderCreateOrUpdate.vue?vue&type=style&index=0&id=bbf53dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf53dd8",
  null
  
)

export default component.exports